'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserPermissionContainer = exports.userPermissionBuilder = undefined;

var _reactRedux = require('react-redux');

var _UserPermission = require('../../Presentational components/Auth/UserPermission/UserPermission');

var _UserPermission2 = _interopRequireDefault(_UserPermission);

var _actions = require('./actions');

var UserPermissionActions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userPermissionBuilder = exports.userPermissionBuilder = function userPermissionBuilder(mapStateToProps) {
  return (0, _reactRedux.connect)(mapStateToProps, UserPermissionActions)(_UserPermission2.default);
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userRoles: state.user.roles
  };
};

var UserPermissionContainer = exports.UserPermissionContainer = userPermissionBuilder(mapStateToProps);


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Container components/UserContainer/UserPermissionContainer.js
 ** module id = 61
 ** module chunks = 0
 **/